function icon(d) {
  return (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d={d} />
    </svg>
  )
}

export const services = [
  {
    id: 'virtual-address',
    title: 'Virtual Business Address',
    price: '$45/mo',
    shortDesc: 'Use our address on your listings without a physical mailbox.',
    homeFeatured: true,
    icon: icon("M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"),
    features: [
      'For clients who want a brick-and-mortar business address on their listings without a physical mailbox',
      'Use as your business address on LLC filings, licenses, and public records',
      'Keep your home address private on public filings and listings',
      'Same building as our Professional Mailbox — 270 E Douglas Ave, El Cajon',
      'Incoming mail is held in a folder at our front desk for pickup, Fridays 9am–12pm',
      'Receives IRS/FTB notices and other government mail delivered by USPS, UPS, or FedEx',
      'Please note: we do not accept or sign for court papers or legal service of process. If your business needs a registered agent, name a separate one on your state filings',
      'Optional Mail Forwarding add-on (+$10/mo) — forwards your mail to an address you provide instead of holding it for Friday pickup; actual postage/handling per piece billed separately',
      'Optional Mail Portal add-on (+$25/mo) — see every piece of mail online the moment it arrives, and choose forward, scan, or shred with one click (requires a forwarding address on file)',
      'Month-to-month — no annual commitment',
    ],
  },
  {
    id: 'professional-address',
    title: 'Professional Mailbox',
    price: '$55/mo',
    shortDesc: 'A real brick-and-mortar address with your own physical mailbox for mail, licensing, and your professional listings. Includes 24/7 personal-code building access, with optional mail forwarding. USPS, UPS, and FedEx accepted, with parking included.',
    homeFeatured: true,
    icon: icon("M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.948V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 7V5z"),
    features: [
      'Everything in the Virtual Business Address, plus a real mailbox',
      'Brick-and-mortar business address at 270 E Douglas Ave, El Cajon — not a PO box or strip mall drop',
      'Physical lobby directory listing (nameplate board in entry lobby)',
      'Incoming mail is sorted and held in your mailbox — pick it up anytime',
      '24/7 building access (personal entry code)',
      'Complimentary on-site parking',
      'USPS, UPS, and FedEx accepted',
      'Receives IRS/FTB notices and other government mail delivered by USPS, UPS, or FedEx',
      'Please note: we do not accept or sign for court papers or legal service of process. If your business needs a registered agent, name a separate one on your state filings',
      'Receives insurance and license renewal notices, vendor invoices, and client mail',
      'Merchant/POS equipment and business deliveries accepted',
      "Usable for California LLC registration and contractor's license applications",
      'Scales with you — keep the same address as your business grows',
      'Listed in our online business directory',
      'Optional Mail Forwarding add-on (+$10/mo) — forwards your mail to an address you provide instead of holding it in your box; actual postage/handling per piece billed separately',
      'Optional Room Discount add-on (+$25/mo) — discounted rates on private offices and the conference room',
      'Optional Mail Portal add-on (+$25/mo) — see every piece of mail online the moment it arrives, and choose forward, scan, or shred with one click (requires a forwarding address on file)',
      'Month-to-month — no annual commitment',
    ],
  },
  {
    id: 'part-time-office',
    title: 'Part-Time Office Space',
    price: 'From $25/hr',
    priceNote: 'Members: hours included with membership',
    shortDesc: 'Bundled with your business address — reserve a private furnished office when you need it. Fully private with a closing door, available for same-day or next-day booking through the front desk. Includes Mon–Fri receptionist phone answering in your company name.',
    homeFeatured: true,
    icon: icon("M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"),
    features: [
      'Everything in the Professional Mailbox plan',
      'Access to private furnished offices by reservation',
      'Offices for client meetings, focused work, or private calls',
      'Fully private with closing doors',
      'Contact front desk to check same-day/next-day availability',
      'Receptionist available Mon–Fri 9am–12pm for live phone answering in your company name',
      'Month-to-month agreement',
    ],
  },
  {
    id: 'full-time-offices',
    title: 'Full-Time Private Offices',
    price: 'From $450/mo',
    shortDesc: 'A dedicated private office with your own suite number, full-time. Closing door for privacy, with a suite number that helps verify your Google My Business listing. On-site receptionist coverage Mon–Fri and complimentary parking included.',
    homeFeatured: true,
    icon: icon("M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"),
    features: [
      'Dedicated private office with closing door',
      'Suite number assigned (helps with Google My Business verification)',
      '35 offices total; availability varies — contact us',
      'Receptionist on-site Mon–Fri 9am–12pm',
      'Complimentary parking',
      'Month-to-month lease',
      'Listing in our online business directory',
      'Publish news & blog posts about your business on our site',
    ],
  },
  {
    id: 'conference-rooms',
    title: 'Conference Room Rental',
    price: 'From $40/hr',
    priceNote: 'Members: hours included with membership',
    shortDesc: 'A fully equipped room for meetings, presentations, and events — open to the public. Presentation-ready with a whiteboard and Zoom-ready webcam available on request. Restrooms nearby, and food and beverages are welcome.',
    homeFeatured: true,
    icon: icon("M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"),
    features: [
      'Open to existing clients and the general public',
      'Presentation-ready setup, whiteboard',
      'Zoom-ready with webcam available',
      'Restrooms nearby',
      'Food and beverages welcome',
      'Cancellation/rescheduling: contact us for details',
    ],
  },
]

// Single source of truth for the business's identity/location fields, shared between Home.jsx's
// LocalBusiness schema and every service page's Service schema below — keeps them from drifting
// out of sync with each other over time.
export const BUSINESS = {
  name: 'East County Business Center',
  telephone: '(619) 401-4000',
  email: 'info@eastcountybiz.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '270 E Douglas Ave',
    addressLocality: 'El Cajon',
    addressRegion: 'CA',
    postalCode: '92020',
    addressCountry: 'US',
  },
  sameAs: ['https://www.facebook.com/ecbiz'],
}

// Builds a schema.org Service entry for one of the services above, for a per-page JSON-LD
// <script> tag (see the individual service pages under src/pages/services/). Prices in this file
// are either a flat rate ("$45/mo") or a starting rate ("From $25/hr") — flat rates map to a plain
// Offer.price, starting rates map to a UnitPriceSpecification.minPrice instead, since claiming a
// single fixed price for something that varies by duration/room would be inaccurate.
export function serviceSchema(service) {
  const price = service.price.match(/[\d.]+/)?.[0] ?? null
  const isStartingPrice = service.price.startsWith('From')

  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: service.title,
    name: service.title,
    description: service.shortDesc,
    areaServed: ['El Cajon, CA', 'San Diego County, CA'],
    provider: {
      '@type': 'LocalBusiness',
      name: BUSINESS.name,
      telephone: BUSINESS.telephone,
      address: BUSINESS.address,
    },
    ...(price ? {
      offers: {
        '@type': 'Offer',
        priceCurrency: 'USD',
        ...(isStartingPrice
          ? { priceSpecification: { '@type': 'UnitPriceSpecification', minPrice: price, priceCurrency: 'USD' } }
          : { price }),
      },
    } : {}),
  }
}
